import React from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import * as yup from 'yup';
import {
  TextField,
  Grid,
  Button,
  Card,
  Typography
} from '@material-ui/core';
import { InfoTooltip } from 'components';
import { createCustomerAccountApi } from 'api';


const emptyUser = {
  firstName: '',
  lastName: '',
  email: ''
};

const RequestAccessForm = ({formInfo, setOpenRequestAccess}) => {
  const dispatch = useDispatch();
  const {title, tooltip} = formInfo;

  return (
    <Formik
      initialValues={{
        user: emptyUser
      }}
      validationSchema={
        yup.object({
          user: yup
            .object().shape({
              firstName: yup
                .string()
                .required('Field is required')
                .ensure().when(['lastName', 'email'], {
                  is: (lastName, email) => lastName || email,
                  then: yup.string().required('Field is required')
                }),
              lastName: yup
                .string()
                .required('Field is required')
                .ensure().when(['firstName', 'email'], {
                  is: (firstName, email) => firstName || email,
                  then: yup.string().required('Field is required')
                }),
              email: yup
                .string()
                .email('Enter valid email')
                .required('Field is required')
                .ensure().when(['firstName', 'lastName'], {
                  is: (firstName, lastName) => firstName || lastName,
                  then: yup.string().required('Field is required')
                })
            }, [
              ['firstName', 'lastName'],
              ['firstName', 'email'],
              ['lastName', 'email']
            ])
        })
      }
      onSubmit={(values, {resetForm}) => {
        createCustomerAccountApi({dispatch,  user: values.user });
        resetForm();
        setOpenRequestAccess(false);
      }}
    >
      {({
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit
      }) => {
        return (
          <form autoComplete="off" onSubmit={handleSubmit} className="mx-auto max-w-600">
            <Card elevation={0} className="p-8 my-10 mx-auto max-w-600">
              <Typography
                variant="body1"
                className="font-semibold text-dark-gray"
              >
                {title}
                {tooltip &&
                  <InfoTooltip
                    title={tooltip}
                  />
                }
              </Typography>
              <Grid container spacing={1} alignItems="center">
                <Grid container spacing={2} item xs={12}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      name={'user.firstName'}
                      className="w-full mt-4"
                      label="First Name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.user?.email && Boolean(errors.user?.firstName)}
                      helperText={touched.user?.email && errors.user?.firstName}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      name={'user.lastName'}
                      className="w-full mt-4"
                      label="Last Name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.user?.email && Boolean(errors.user?.lastName)}
                      helperText={touched.user?.email && errors.user?.lastName}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      name={'user.email'}
                      className="w-full mt-4"
                      label="Email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.user?.email && Boolean(errors.user?.email)}
                      helperText={touched.user?.email && errors.user?.email}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Card>
            <Button
              color="primary"
              variant="contained"
              className="min-w-100 mr-4"
              type="submit"
            >
              Create
            </Button>
            <Button
              variant="contained"
              onClick={() => setOpenRequestAccess(false)}
            >
              Cancel
            </Button>
          </form>
        );
      }}
    </Formik>
  );
};

export default RequestAccessForm;
